import { Box } from '@mui/material'
import AccesosDirectos from 'common/components/AccesosDirectos'
import Avisos from 'features/avisos/components/Avisos'
import { selectUsuario } from 'features/users/stores/userSlice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ThemeController from 'theming/ThemeManager' // importar el controlador general
import DefaultLoginBackGround from '../components/LoginBackground'
import DefaultLoginForm from '../components/LoginForm'
import DefaultRecoveryPasswordForm from '../components/RecoveryPasswordForm'

const Login = () => {
  const navigate = useNavigate()
  const usuario = useSelector(selectUsuario)
  useEffect(() => {
    if (usuario && usuario?.usuario_web) {
      navigate('/')
    }
  }, [usuario])

  const themeController = new ThemeController() // instanciar el controlador
  const LoginBackground = themeController?.components
    ? (themeController?.components['LoginBackground'] ?? DefaultLoginBackGround)
    : DefaultLoginBackGround

  const LoginForm = themeController?.components
    ? (themeController?.components['LoginForm'] ?? DefaultLoginForm)
    : DefaultLoginForm
  const RecoveryPasswordForm = themeController?.components
    ? (themeController?.components['RecoveryPasswordForm'] ?? DefaultRecoveryPasswordForm)
    : DefaultRecoveryPasswordForm

  const location = useLocation()
  const [loading, setLoading] = useState(false)
  return (
    <>
      <LoginBackground loading={loading}>
        {location?.state?.recovery ? (
          <RecoveryPasswordForm />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'end',
              width: '100%',
              gap: 2,
              flexWrap: { xs: 'wrap', md: 'initial' },
              justifyContent: { xs: 'center', md: 'initial' },
            }}
            id={'login-box'}
          >
            <LoginForm loadingParentCallback={setLoading} />
            <Box id={'login-quick-info'}>
              <Avisos
                closable={false}
                sx={{ flex: { xs: '1 1 100%', md: '1 1 40%' } }}
                mode="box"
              />
              <AccesosDirectos
                codigo="LOGIN"
                sx={{
                  mt: 1,
                  justifyContent: { xs: 'center' },
                  display: { xs: 'flex', md: 'block' },
                }}
                sxCardMedia={{
                  backgroundSize: '100% 100%',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
                sxInnerBox={{
                  justifyContent: 'center',
                }}
              />
            </Box>
          </Box>
        )}
      </LoginBackground>
    </>
  )
}

export default Login
